export type MedicalRecord = {
  personaId: string;
  personaCode: string;
  recordCode: string;
  personaName: string;
  chiefComplaint: string;
  pathologyAnalysis: string;
  symptom1: string;
  symptom2: string;
  symptom3: string;
  companionExplanation?: string;
  colleagueView: string;
  advice1: string;
  advice2: string;
  advice3: string;
  shareQuote?: string;
  qrTitle: string;
  qrSubtitle: string;
  disclaimer: string;
};

const shared = {
  qrTitle: "扫码测测你的单位病症",
  qrSubtitle: "6 道题，生成你的发病人格。",
  disclaimer: "本病历仅供单位发疯娱乐，不构成医学或心理诊断。",
};

export const medicalRecords: MedicalRecord[] = [
  {
    personaId: "risk-bumper",
    personaCode: "RISK-BUMPER",
    recordCode: "RISK",
    personaName: "责任保险杠",
    chiefComplaint: "你总能提前听见责任要撞过来的声音。",
    pathologyAnalysis:
      "你不是天生爱划边界，是太清楚没有边界的事最后会长出解释人。口头安排、临时协调、模糊牵头，听起来像信任，落到你身上常常是默认兜底入口。",
    symptom1: "听到“你来牵头”，第一反应不是怎么干，而是谁授权、谁确认、谁背书。",
    symptom2: "别人还在说“先推进”，你已经在脑内生成一版情况说明。",
    symptom3: "口头安排刚落地，你的截图和纪要系统已经自动启动。",
    companionExplanation:
      "你不是消极推责，而是见过太多“没人说清”的事，最后都被默认成“你当时应该知道”。",
    colleagueView:
      "同事觉得你谨慎、爱留痕，但你知道，那是被太多没有边界的责任撞出来的条件反射。",
    advice1: "任何“你来牵头”入口处，请先摆放责任边界警示牌。",
    advice2: "口头安排可以听，截图和纪要要及时接种。",
    advice3: "不要把别人的沉默，自动翻译成你的责任。",
    shareQuote: "你怕的不是牵头，是一句“你来”之后，所有解释都归你。",
    ...shared,
  },
  {
    personaId: "cross-sandwich",
    personaCode: "CROSS-SANDWICH",
    recordCode: "CROSS",
    personaName: "跨部门夹心饼",
    chiefComplaint: "你没有权限，却经常负责交付一个需要权限才能完成的结果。",
    pathologyAnalysis:
      "你不是不会协调，是被放在了最适合传压、最不适合拍板的位置。上面要进度，横向要态度，下面要资源，最后所有“不归我管”都会在你这里变成“你再沟通一下”。",
    symptom1: "最常听到的是“你协调一下”，但没人给你协调所需的权限。",
    symptom2: "同一件事，你要把 A 的难处翻译给 B，再把 B 的不动解释给 A。",
    symptom3: "你不是在推进项目，是在几个聊天框之间做压力中转。",
    companionExplanation:
      "你的疲劳不是来自沟通次数，而是来自每次沟通都没有真正的调度权。你夹在中间，不是因为你适合，而是因为你最好说话。",
    colleagueView: "同事觉得你会沟通、好配合，但你知道，所谓好协调，经常是好被夹。",
    advice1: "接到“协调一下”前，先问清你手里有没有调度权。",
    advice2: "不要把别人的不配合，包装成自己的推进不力。",
    advice3: "传话可以，但不要长期兼职人肉缓冲垫。",
    shareQuote: "最难的不是协调，是你没有权限，却要替所有人的不动交差。",
    ...shared,
  },
  {
    personaId: "coord-tracker",
    personaCode: "OA-TRACKER",
    recordCode: "OA",
    personaName: "OA追更人",
    chiefComplaint: "流程卡在别人那里，血压长在你这里。",
    pathologyAnalysis:
      "你不是爱催 OA，是知道流程卡住时，最先被问的往往不是没点按钮的人，而是那个负责“跟进”的人。你没有审批权，却被流程的停滞反复点名。",
    symptom1: "刷 OA 状态像刷物流，只是包裹里装的是你的下班时间。",
    symptom2: "催人时最耗费的不是内容，而是那句“麻烦您方便时看一下”的语气折旧。",
    symptom3: "系统显示“待处理”，你的人生也跟着卡在待处理。",
    companionExplanation:
      "你盯的不是按钮本身，而是责任有没有继续往前走。每一次“已流转”，都像给你的精神后台释放一点内存。",
    colleagueView: "同事觉得你很会跟进，但你知道，跟进不是权力，是消耗。",
    advice1: "催办前先验明病因：缺材料、缺意见，还是单纯没人点。",
    advice2: "能用节点表解决的，不要靠“在吗”燃烧人格。",
    advice3: "OA 不动不代表你没努力，可能只是按钮那头的人精神离线。",
    shareQuote: "流程不更新，你的人生也卡在加载中。",
    ...shared,
  },
  {
    personaId: "interrupt-shelter",
    personaCode: "INTERRUPT-SHELTER",
    recordCode: "INT",
    personaName: "临时插单收容所",
    chiefComplaint: "你的计划不是计划，是别人临时需求的候诊区。",
    pathologyAnalysis:
      "你不是响应快，是你的工作节奏长期被征用。每个插单都说自己很急，每个“方便吗”都像无法拒绝，最后你的原计划只剩下被延期的资格。",
    symptom1: "刚打开一个文档，右下角就弹出一个“方便吗”。",
    symptom2: "你的一天不是按计划推进，是按突发事项重新排序。",
    symptom3: "你已经能从语气判断这次“帮个忙”会吞掉几个小时。",
    companionExplanation:
      "插单不是偶发事件，而是你的日程系统默认对外开放。久而久之，你不是在安排工作，是在给别人的紧急程度腾病床。",
    colleagueView: "同事觉得你响应快、好配合，但你知道，快只是因为没机会慢。",
    advice1: "临时任务入院前，先挂号：谁提、何时要、优先级凭什么。",
    advice2: "不要让每一句“很急”，都自动覆盖你正在做的正事。",
    advice3: "给自己留一块不可插队时间，否则你的计划会长期住在走廊加床。",
    shareQuote: "每个临时任务都说自己很急，没人问你原本在忙什么。",
    ...shared,
  },
  {
    personaId: "tone-compiler",
    personaCode: "TONE-COMPILER",
    recordCode: "TONE",
    personaName: "口径编译器",
    chiefComplaint: "你擅长把真实情况翻译成能被系统接住的话。",
    pathologyAnalysis:
      "你不是不说真话，而是太清楚真话不能裸奔进材料。你会先判断这句话能不能上报、谁听了会不会接得住、风险会不会被放大成新问题，然后再把现实编译成一种更安全的组织语言。",
    symptom1: "“没进展”会自动变成“持续推进”。",
    symptom2: "看到一句大白话，第一反应是它能不能出现在汇报材料里。",
    symptom3: "一个事实可以切出三种口径：对上、对内、对外。",
    companionExplanation:
      "你不只是会组织表达，还会盯着这套表达有没有被流程接住。话发出去了不算完，能不能被系统吸收，才决定它是不是安全。",
    colleagueView: "同事会觉得你表达稳、材料也稳，但你自己知道，稳的背后是大量删改。",
    advice1: "先留一版真实底稿，防止口径修到最后连自己都找不到事实。",
    advice2: "风险可以包装成条件，但不要包装成不存在。",
    advice3: "润色到第三版时，请检查你是不是已经开始替现实道歉。",
    shareQuote: "真实情况很复杂，汇报口径很稳定。",
    ...shared,
  },
  {
    personaId: "flow-monk",
    personaCode: "FLOW-MONK",
    recordCode: "FLOW",
    personaName: "流程苦行僧",
    chiefComplaint: "没走完流程的事，在你心里像还没真正发生。",
    pathologyAnalysis:
      "你不是崇拜流程，是知道在单位里，没有留痕的努力很容易被系统删除。线上、纸质、会签、归档，每一步都不是形式，而是给现实盖章，证明它曾经被认真办过。",
    symptom1: "听到“先办着”，你会本能追问：流程呢？",
    symptom2: "线上已经走完，但纸质版没补齐，你还是觉得事情悬着。",
    symptom3: "你能准确说出一个事项还缺哪一环才算“真的办完”。",
    companionExplanation:
      "你的流程焦虑不是拖延，而是风险记忆。你见过太多“当时没走流程”的事，最后在复盘时突然变成问题本身。",
    colleagueView: "同事觉得你讲流程、讲规矩，但你知道，你是在替未来减少返工和解释。",
    advice1: "流程清单提前贴墙，不要等返工时再考古。",
    advice2: "必要流程要走，但别把每一次补材料都当成组织修行。",
    advice3: "能一次性说清的材料要求，不要分三次补齐。",
    shareQuote: "无纸化的尽头，是打印出来签字。",
    ...shared,
  },
  {
    personaId: "rework-tamer",
    personaCode: "REWORK-TAMER",
    recordCode: "REWORK",
    personaName: "返工驯兽师",
    chiefComplaint: "你一边确认最终版，一边知道它不会最终。",
    pathologyAnalysis:
      "你怕的不是多改一版，而是每一次“就这样定了”都可能在下一个小时失效。确认、推翻、重做、再确认，返工真正伤人的不是劳动量，而是确认感的反复作废。",
    symptom1: "看到“再按新口径改一版”，心里会先给旧版建个坟。",
    symptom2: "文件名里出现过“最终版”“最终终版”“真的最终版”“以这个为准”。",
    symptom3: "你不是怕修改，你是怕确认之后又重来。",
    companionExplanation:
      "你已经被训练出返工预判能力。别人说“最后再看一眼”，你听见的是野兽在笼子里翻身。",
    colleagueView: "同事觉得你能改、抗压，但你知道，你是在驯服一只永远不肯定稿的野兽。",
    advice1: "每次返工先问“本轮只改哪里”，不要整篇献祭。",
    advice2: "版本记录必须留，不要让返工变成集体失忆。",
    advice3: "听到“再微调一下”时，先确认这只野兽会不会继续繁殖。",
    shareQuote: "最终版只是下一轮返工前的安慰剂。",
    ...shared,
  },
  {
    personaId: "ask-recv",
    personaCode: "ASK-RECV",
    recordCode: "ASK",
    personaName: "批示接收器",
    chiefComplaint: "没有那句“同意”，你的系统不敢进入执行区。",
    pathologyAnalysis:
      "你不是没有判断，是知道在某些事项里，判断本身不是能力问题，而是授权问题。没有批示，做慢了叫拖；做快了可能叫擅自；做对了也未必安全。",
    symptom1: "方案已经写好，但你还在等“请领导阅示”后的那两个字。",
    symptom2: "一遇到边界不清的事，先判断谁有资格说可以。",
    symptom3: "你最怕的不是没方案，而是方案没有被确认过。",
    companionExplanation:
      "你的等待不是低效，而是授权焦虑。你知道先判断的人往往也会先承担后果，所以你在等的不是意见，是护身符。",
    colleagueView: "同事觉得你稳、守规矩，但你知道，稳是因为你不想替别人拍板。",
    advice1: "请示前先准备选项，不要只把问题原样上供。",
    advice2: "能按制度判断的事，不必全部送进批示等待区。",
    advice3: "批示落地后，立刻翻译成责任人、动作和时间点。",
    shareQuote: "你不是没判断，是知道判断需要授权。",
    ...shared,
  },
  {
    personaId: "loop-judge",
    personaCode: "LOOP-JUDGE",
    recordCode: "LOOP",
    personaName: "销号判官",
    chiefComplaint: "问题不闭环，你就无法精神下班。",
    pathologyAnalysis:
      "你不是爱较真，是知道没有证据链的问题，总有一天会重新打开。整改、台账、截图、回头看、销号，不只是流程，是把问题从组织记忆里安全送走的仪式。",
    symptom1: "事情做完不算完，销号了才算完。",
    symptom2: "看到“持续推进”，你会本能怀疑它是不是完成不了的别名。",
    symptom3: "你会反复确认截图、台账、附件能不能支撑闭环。",
    companionExplanation:
      "你的闭环执念不是形式主义，而是复发恐惧。只要证据链不完整，这个问题就随时可能在某次检查里诈尸。",
    colleagueView: "同事觉得你盯得紧，但你知道，闭环不是形式，是自保。",
    advice1: "整改前先问清销号标准，不然你会在“持续推进”里反复投胎。",
    advice2: "证据链一次列清，别让材料像连续剧一样每周更新。",
    advice3: "不要让“持续推进”长期冒充“已经完成”。",
    shareQuote: "没有证据链的问题，总有一天会重新打开。",
    ...shared,
  },
  {
    personaId: "meet-cell",
    personaCode: "MEET-CELL",
    recordCode: "MEET",
    personaName: "会议繁殖体",
    chiefComplaint: "不确定性一出现，你就想给它找个会议室。",
    pathologyAnalysis:
      "你不是爱开会，是知道会议能把没有结论的事合法延期，也能把没人拍板的风险均匀摊开。会议有时不是为了解决问题，而是为了证明问题被集体看见过。",
    symptom1: "一个问题进会议室前叫问题，出来以后叫专项推进事项。",
    symptom2: "一句“会后再碰一下”，能把一个问题复制出新问题。",
    symptom3: "事项越模糊，参会范围越容易扩大。",
    companionExplanation: "很多结论没有被敲定，只是被转移到下一次议程里继续存活。",
    colleagueView: "同事觉得你爱拉会，但你知道，很多会其实是在替没有结论的事情找缓冲区。",
    advice1: "开会前先写清楚本次到底要定什么，不要召唤一屋子人陪问题散步。",
    advice2: "没有决策事项的会，尽量降级成信息同步。",
    advice3: "会后只保留责任人、时间点和明确结论，其余客套请原地安葬。",
    shareQuote: "一场会解决不了问题，但能把问题合法延期。",
    ...shared,
  },
  {
    personaId: "power-save-worker",
    personaCode: "POWER-SAVE",
    recordCode: "SAVE",
    personaName: "工位节能人",
    chiefComplaint: "你不是摆烂，是长期消耗后进入低功耗保护。",
    pathologyAnalysis:
      "你不是不想积极，是每一次积极都可能被系统识别为“这个人还能接”。于是你学会降低响应功率：能不卷入就不卷入，能少解释就少解释，把电量留给真正躲不过的事。",
    symptom1: "看到新消息，第一反应不是回复，而是判断它是否必须由你回复。",
    symptom2: "听到“工作不饱和”，精神电量会直接下降。",
    symptom3: "你不是不知道，而是不想再多知道一件事。",
    companionExplanation:
      "你的低功耗不是懒，而是自保算法。长期被打断、被加码、被默认可用之后，你学会了不给所有噪音供电。",
    colleagueView: "同事觉得你很佛、很稳，但你知道，你是在单位环境里维持最低生存功耗。",
    advice1: "把电量留给关键节点，不要被每个噪音唤醒。",
    advice2: "低功耗不是彻底断电，真正躲不过的事项仍要保留响应速度。",
    advice3: "别让自己长期后台运行，偶尔也要主动清缓存。",
    shareQuote: "你不是没电，是学会了不给所有噪音供电。",
    ...shared,
  },
  {
    personaId: "doc-decor",
    personaCode: "DOC-DECOR",
    recordCode: "DOC",
    personaName: "材料精装修师",
    chiefComplaint: "问题可以没解决，但材料必须看起来解决过。",
    pathologyAnalysis:
      "你不是迷恋格式，是知道很多事情最后不是看解决了什么，而是看留下了什么材料。标题、附件、支撑、截图、表述层级，都是你替现实补光、遮瑕、打磨交付感的工具。",
    symptom1: "内容还没完全想清，模板已经先找好了。",
    symptom2: "你能把普通动作写出专项推进的质感。",
    symptom3: "缺支撑材料时，你会比缺结论还焦虑。",
    companionExplanation:
      "你的精装修不是审美洁癖，而是交差焦虑。你知道材料经常决定一件事看起来有没有被重视，哪怕现实本身还没那么完整。",
    colleagueView: "同事觉得你材料精致、格式稳，但你知道，精装修背后经常是给无效动作补体面。",
    advice1: "先确认材料用途，再决定装修等级，别把普通动作装成重点工程。",
    advice2: "能一页说清的，不要为了显得重视写成十页。",
    advice3: "支撑材料要服务结论，不要反过来绑架事实。",
    shareQuote: "有些问题不是被解决的，是被材料装修到看起来解决了。",
    ...shared,
  },
];

export const medicalRecordByPersonaName = new Map(
  medicalRecords.map((record) => [record.personaName, record]),
);

export const medicalRecordByPersonaCode = new Map(
  medicalRecords.map((record) => [record.personaCode, record]),
);
